import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    formataTableCellHeadExibeDadosTexto,
    formataTableCellHeadExibeDadosValor,
    formataTableCellBodyExibeDadosTexto,
    formataTableCellBodyExibeDadosValor,
} from '../../../business-components/Formata/Formata'

import {
    round
} from '../../../business-components/round/round'

import {
    TableExibeDados,
    TableHeadExibeDados,
    TableRowHeadExibeDados,
    TableBodyExibeDados,
    TableRowBodyExibeDados,
    TableCellBodyExibeDados,
} from '../../../business-components/Table/TableExibeDados'



const SimulacaoFinanceiraReportAporteRetiradaMensal = ( { values } ) => {

    const AporteRetiradaMensal = () => {

        const report = true

        const aumentoLetraCabecalho = 4
        const aumentoLetraReportCabecalho = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 3 : 5
        
        const aumentoLetra = 4
        const aumentoLetraReport = values.disposicaoRelatorio === HARDCODE.disposicaoRelatorioRetrato ? 4 : 6

        let headList = [
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.idadeInicial, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 2,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.idadeFinal, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.aporteMensal, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 4,
                headTitle: formataTableCellHeadExibeDadosValor(LABEL.retiradaMensal, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
            {
                colSpan: 10,
                headTitle: formataTableCellHeadExibeDadosTexto(LABEL.observacao, report, aumentoLetraCabecalho,
                    aumentoLetraReportCabecalho, values),
            },
        ]



        return (
            <div
                className='mt-10'
            >
                <h3>
                    {LABEL.aportesRetiradasMensais}
                </h3>
                
                <TableExibeDados
                    report={report}
                    noMinW={true}
                >
                    <TableHeadExibeDados
                        report={report}
                    >
                        <TableRowHeadExibeDados
                            dados={headList}
                        />
                    </TableHeadExibeDados>

                    <TableBodyExibeDados>
                        {values.aporteRetiradaMensal?.map((item, ind) => {
                            return (
                                <TableRowBodyExibeDados
                                    key={ind}
                                    report={report}
                                >
                                    <TableCellBodyExibeDados
                                        colSpan={headList[0].colSpan}
                                        primeiraColuna={true}
                                    >
                                        {formataTableCellBodyExibeDadosTexto(item.idadeInicial, report, false,
                                            aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>
                                    
                                    <TableCellBodyExibeDados
                                        colSpan={headList[1].colSpan}
                                    >
                                        {formataTableCellBodyExibeDadosTexto(item.idadeFinal, report,
                                            false, aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[2].colSpan}
                                    >
                                        {formataTableCellBodyExibeDadosValor(round(item.aporteMensal, 2), report, false,
                                            false, aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[3].colSpan}
                                    >
                                        {formataTableCellBodyExibeDadosValor(round(item.retiradaMensal, 2), report,
                                            false, false, aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>

                                    <TableCellBodyExibeDados
                                        colSpan={headList[4].colSpan}
                                    >
                                        {formataTableCellBodyExibeDadosTexto(item.observacao, report,
                                            false, aumentoLetra, aumentoLetraReport, values)}
                                    </TableCellBodyExibeDados>
                                </TableRowBodyExibeDados>
                            )
                        })}
                    </TableBodyExibeDados>
                </TableExibeDados>
            </div>
        )
    }

    return (
        values.aporteRetiradaMensal && values.aporteRetiradaMensal.length > 0
            ?
                <AporteRetiradaMensal/>
            :
                ''
    )
}

export default SimulacaoFinanceiraReportAporteRetiradaMensal